import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "0",
    A_PostDt: new Date(),
    A_RefDt: new Date(),
    A_RefNo: "",
    A_Party: "",
    A_PartyName: "",
    A_Curr: "",
    A_Currname: "",
    A_ExRate: "1",
    A_PayMode: "CASH",
    A_Type: "Retail",
    A_Loc: "",
    A_Buyer: "", ////SalesMan
    A_Narr: "",

    A_DiscPerc: (0).toFixed(2),
    A_DiscAmt: (0).toFixed(2),
    A_Rounding: (0).toFixed(2),
    A_NetAmt: 0,
    A_LC: 0,
    A_Charges1: 0,
    A_Charges2: 0,
    A_DocStat: "ENTER",
    A_CUSTFIELD1: "",
    A_CUSTFIELD3: "OTTRN001",
    A_CUSTFIELD4: "N",
    A_CUSTFIELD5: "", //-- LOading Pay ,
    A_CUSTFIELD6: "",
    A_CUSTFIELD7: "",
    A_CUSTFIELD8: "",
    A_CUSTFIELD9: "",
    A_CUSTFIELD10: "",
    A_ExciseTaxNetAmt: 0,
    PKD: "N",
    A_TaxGross: "N",
    A_Taxable: "Y",
    IsStockReserved: "Y",
    A_SalesGroup: "", //SalesGroup
    LDP: "N",
    A_Party_TRN: "",
    A_Br_TRN: "",
    A_GST_Type: "",
    A_NetAmt_Arabic: "",
    A_VATRefNo: "",
    A_InstantPick: "N",
  },
  SalesOrderCheckbox: {
    UnitRateLC: false,
    LDisc: false,
    TDisc: false,
    Foc: false,
    Excise: false,
    Taxable: true,
    SalesOrder:false,
    Narration: true,
    Incentive: true,
    RefDoc:true,
    ItemCode:true,
    Loction:true,
    PackQty:true,
  },

  WmsInnContent: {},
};

const SliceSalesOrder = createSlice({
  name: "SliceSalesOrder",
  initialState: { value: initialState },

  reducers: {
    SalesOrder_Init: (state) => {
      state.value = initialState;
    },
    Set_SalesOrder_Checkbox: (state, action) => {
      state.value.SalesOrderCheckbox = action.payload;
    },
    SalesOrder_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },
    Set_SalesOrder_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },

    Set_SalesOrder_HeadObject_New: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_Loc = action.payload.A_Loc;
      state.value.HeadObject.A_Curr = action.payload.A_Curr;
      state.value.HeadObject.A_ExRate = action.payload.A_ExRate;
      state.value.HeadObject.A_Type = action.payload.A_Type;
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.A_CUSTFIELD3 = action.payload.A_CUSTFIELD3;
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
      state.value.HeadObject.A_SalesGroup = action.payload.A_SalesGroup;
    },

    Set_SalesOrder_HeadObject_VocNo_Doc: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_SalesOrder_HeadObject_SalesGroup_SalesMan: (state, action) => {
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.A_SalesGroup = action.payload.A_SalesGroup;
    },
    Set_SalesOrder_HeadObject_DocStatus: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_SalesOrder_HeadObject_Party: (state, action) => {
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
    },

    Set_SalesOrder_HeadObject_PayMode: (state, action) => {
      state.value.HeadObject.A_PayMode = action.payload.A_PayMode;
    },
    Set_HeadObject_Type: (state, action) => {
      console.log('Dispatching A_Type:', action.payload.A_Type)
      state.value.HeadObject.A_Type = action.payload.A_Type;
    },
  },
});

export const {
  SalesOrder_Init,
  Set_SalesOrder_HeadObject_Set,
  Set_SalesOrder_HeadObject_New,
  Set_SalesOrder_HeadObject_VocNo_Doc,
  Set_SalesOrder_HeadObject_DrCrAccount,
  Set_SalesOrder_HeadObject_DocStatus,
  Set_SalesOrder_HeadObject_PayMode,
  Set_SalesOrder_HeadObject_SalesGroup_SalesMan,
  Set_SalesOrder_HeadObject_Party,
  SalesOrder_HeadObject_Init,
  Set_SalesOrder_Checkbox,
  Set_HeadObject_Type
} = SliceSalesOrder.actions;
export default SliceSalesOrder.reducer;
